import { __assign } from "tslib";
import { useToggle } from '../toggle';
export function useSwitch(props, inputRef) {
    var toggle = useToggle(props, inputRef);
    return __assign(__assign({}, toggle), { inputProps: __assign(__assign({}, toggle.inputProps), { role: 'switch' }) });
}
